// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los Carteles de las distintas manos
 * @param {*} scene
 */
export function cargaAssetsCartelesMano(scene) {
  // Assets de los carteles
  scene.load.image(
    "cartelManoBlackJack",
    ROUTES.rutaBlackJackCartelesMano + "/cartelMano1BlackJackResized.png"
  );
  scene.load.image(
    "cartelManoGana",
    ROUTES.rutaBlackJackCartelesMano + "/cartelMano2GanaResized.png"
  );
  scene.load.image(
    "cartelManoEmpate",
    ROUTES.rutaBlackJackCartelesMano + "/cartelMano3EmpateResized.png"
  );
  scene.load.image(
    "cartelManoPierde",
    ROUTES.rutaBlackJackCartelesMano + "/cartelMano4PierdeResized.png"
  );
  scene.load.image(
    "cartelManoExcede21",
    ROUTES.rutaBlackJackCartelesMano + "/cartelMano5Excede21Resized.png"
  );

}
